import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function LatestNews() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/posts`)
      .then((r) => Array.isArray(r.data) && setPosts(r.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section id="news" className="relative px-4 md:px-8 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end mb-12">
          <div>
            <span className="eyebrow">Health blog</span>
            <h2 className="section-title">Health tips & practice updates</h2>
          </div>
          <div className="lg:ml-auto">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 text-[#1a2464] font-semibold hover:text-[#3dc9b3]"
            >
              View all articles <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={`/news/${p.slug}`}
              className="group bg-white rounded-3xl overflow-hidden border border-[#eee6f7] shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <div className="aspect-[16/10] overflow-hidden bg-[#eae6f6]">
                <img
                  src={p.cover}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-flex bg-[#3dc9b3]/15 text-[#1a2464] font-semibold text-[11px] px-3 py-1 rounded-full">
                    {p.category}
                  </span>
                  <span className="text-[#6b6b85] text-xs inline-flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {p.read_time}
                  </span>
                </div>
                <h3 className="font-bold text-[#1a2464] text-lg leading-snug mb-3 group-hover:text-[#3dc9b3] transition-colors">
                  {p.title}
                </h3>
                <p className="text-[#4a4a63] text-sm leading-relaxed line-clamp-3">{p.excerpt}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="text-[#6b6b85] text-xs inline-flex items-center gap-1">
                    <Calendar className="w-3 h-3" /> {formatDate(p.published_at)}
                  </span>
                  <span className="text-[#1a2464] font-semibold text-sm inline-flex items-center gap-1 group-hover:text-[#3dc9b3]">
                    Read <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
